export interface WelcomeStep {
  number: number;
  title: string;
  description: string;
}

export interface WelcomeContent {
  title: string;
  subtitle: string;
  description: string;
  steps: WelcomeStep[];
  ctaText: string;
  footerNote: string | null;
}

export const welcomeModalContent: Record<'free' | 'paid', WelcomeContent> = {
  free: {
    title: "Welcome to GreenLight! 🎉",
    subtitle: "You're all set to streamline your email reviews",
    description: "GreenLight makes it easy to get feedback on your emails from stakeholders — no more endless email chains or confusing threads.",
    steps: [
      {
        number: 1,
        title: "Create a project",
        description: "Start by creating your first email project"
      },
      {
        number: 2,
        title: "Upload your email",
        description: "Forward your email HTML to get started"
      },
      {
        number: 3,
        title: "Share for feedback",
        description: "Send a review link to your stakeholders"
      }
    ],
    ctaText: "Create Your First Project",
    footerNote: "You're on the Free plan with 1 active project."
  },
  paid: {
    title: "Welcome to GreenLight! 🎉",
    subtitle: "Thanks for subscribing — let's get you started",
    description: "You've made a great choice! GreenLight will transform how you collaborate on email reviews with stakeholders.",
    steps: [
      {
        number: 1,
        title: "Create a project",
        description: "Start by creating your first email project"
      },
      {
        number: 2,
        title: "Upload your email",
        description: "Forward your email HTML to get started"
      },
      {
        number: 3,
        title: "Share for feedback",
        description: "Send a review link to your stakeholders"
      }
    ],
    ctaText: "Create Your First Project",
    footerNote: null
  }
};
